export default __webpack_public_path__ + "static/media/author.8c8f3a20.png";